// extracted by mini-css-extract-plugin
module.exports = {"cherryInfoWrapper":"ClientCherryInfo_cherryInfoWrapper__1QhXc","title":"ClientCherryInfo_title__R9B9u","itemText":"ClientCherryInfo_itemText__1uGSQ"};